import React from "react";

function NFTWalletDevS() {
  return (
    <>
      <div>
        <div className="container p-5">
          <div
            className="pricing-style-one-item-cos bg-dark text-light"
            style={{
              backgroundImage:
                "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
            }}
          >
            <div className="text-center">
              <h3>NFT Wallet Development Service</h3>
              <div className="bottom">
                <div className="pricing">
                  <p>
                    Xeer Technology offers a comprehensive NFT Wallet
                    Development service designed to provide users with a
                    seamless, secure, and scalable experience for managing their
                    digital assets. Our expert team builds custom NFT wallets
                    that support multiple blockchain networks, including
                    Ethereum, Solana, and others, ensuring compatibility with a
                    wide range of decentralized applications (dApps).
                  </p>
                </div>
                <a className="btn btn-style-one mt-30" href="#">
                  Get Started
                </a>
              </div>
            </div>
            {/* <div className="right-info"></div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTWalletDevS;
